// orthoTileCache.js — pure filter to reconcile cached ortho tiles against current paths.
// Tiles are cached client-side (IndexedDB, keyed by projectId) as a flat list spanning
// every path ever loaded in this browser. A path's Drive folder can be hard-deleted (or
// replaced by a regenerate) without that browser's cache ever being told, so a tile whose
// pathId no longer matches a live path is dead weight — it will 404 forever. Drop it.

/** Keep only tiles whose pathId matches one of the given (still-existing) paths. */
export function filterOrthoTilesByPaths(tiles, paths) {
  if (!Array.isArray(tiles)) return [];
  const validIds = new Set(
    (Array.isArray(paths) ? paths : []).map((p) => p?.id).filter(Boolean),
  );
  return tiles.filter((t) => t?.pathId && validIds.has(t.pathId));
}
